
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.509 8.338a4.169 4.169 0 100-8.338 4.169 4.169 0 000 8.338z","fill":"#E7E5EC"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.424 20H.584c-.34 0-.61-.29-.582-.628.839-8.819 6.841-9.219 8.502-9.226 1.66.007 7.663.407 8.502 9.226a.583.583 0 01-.582.628z","fill":"#E7E5EC"}})])
          )
        }
      }
    